<template>
  <v-dialog
    content-class="rounded-xl"
    v-model="dialog_sub_stm_visible"
    @click:outside="closeDialog"
    width="1200px"
  >
    <v-form ref="form">
      <v-card min-height="400px">
        <v-card-title>
          <div class="d-flex justify-start">
            <p class="text-h5 ma-0">Подача заявления</p>
          </div>
          <v-spacer/>
          <div lass="d-flex justify-end">
            <v-btn @click="closeDialog" icon>
              <v-icon size="20">fa-times</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-divider/>
        <v-tabs
          color="teal"
          :value="activeTab"
          @change="setActiveTab"
          centered
          fixed-tabs
          icons-and-text
        >
          <v-tab :disabled="Number(activeTab) !== 0">Общая информация</v-tab>
          <v-tab :disabled="Number(activeTab) !== 1">Тип заявления</v-tab>
          <v-tab :disabled="Number(activeTab) !== 2">Персональная информация</v-tab>
          <v-tab :disabled="Number(activeTab) !== 3">Выбор места</v-tab>
        </v-tabs>
        <v-tabs-items :value="activeTab" @change="setActiveTab">
          <v-tab-item>
            <GeneralInfo/>
          </v-tab-item>
          <v-tab-item style="height: 400px">
            <TypeStatement/>
          </v-tab-item>
          <v-tab-item>
            <PersInfo/>
          </v-tab-item>
          <v-tab-item>
            <ChoosePlace :dialog_sub_stm_visible="dialog_sub_stm_visible" @closeDialog="closeDialog"/>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
    import GeneralInfo from "../Tabs/TabsInStatement/GeneralInfo";
    import ChoosePlace from "../Tabs/TabsInStatement/ChoosePlace";
    import PersInfo from "../Tabs/TabsInStatement/PersInfo";
    import TypeStatement from "../Tabs/TabsInStatement/TypeStatement";
    import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

    export default {
        name: "DialogSubmitStatement",
        props: {
            dialog_sub_stm_visible: {
                type: Boolean
            }
        },
        data: () => ({}),
        components: {
            GeneralInfo,
            ChoosePlace,
            PersInfo,
            TypeStatement

        },
        mounted: function () {
        },
        computed: {
            ...mapState({
                activeTab: state => state.interactionStatement.activeTab,
            }),
            ...mapGetters({}),
        },
        watch: {},
        methods: {
            ...mapMutations({
                setActiveTab: 'interactionStatement/setActiveTab',
            }),
            ...mapActions({
            }),
            closeDialog() {
                this.$emit('updateVisibleDialog', {
                    dialog_sub_stm_visible: !this.dialog_sub_stm_visible,
                })
            },
        },
    }
</script>

<style scoped>

</style>